import React, { createContext, useState, useContext, useEffect } from 'react';

// 1. Vi skapar själva kontexten (det osynliga molnet)
const LanguageContext = createContext();

// 2. Vi skapar en "Provider". Detta är motorn som håller koll på språket
// och skickar ner det till alla komponenter (children) inuti den.
export const LanguageProvider = ({ children }) => {
  // Leta i minnet först. Finns det inget sparat, använd 'English' (måste matcha translations.js exakt!)
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('app_language');
    return savedLanguage || 'English';
  });

  const languages = ['Swedish', 'English', 'Norwegian', 'Danish', 'Finnish', 'Italian', 'French', 'German', 'Spanish', 'Portuguese', 'Hindi', 'Mandarin'];

  // Varje gång språket ändras, spara ner det i enhetens minne
  useEffect(() => {
    localStorage.setItem('app_language', language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};

// 3. En liten genväg (hook) så att dina andra filer enkelt kan sträcka upp handen 
// och hämta språket genom att bara skriva: const { language } = useLanguage();
export const useLanguage = () => {
  return useContext(LanguageContext);
};